module.exports = __webpack_public_path__ + "img/new.430ca828.jpg";